<template>
  <div class="back-menu-container">
    <button
      :to="to"
      class="back"
      @click.prevent="onSubmit"
    >
      <i class="icon-arrow-b" />
    </button>
    <div class="title">
      <h3>{{ title }}</h3>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      // eslint-disable-next-line vue/require-default-prop,vue/require-prop-types
      title: {},
      to: {
        type: Object,
        default: () => ({ name: 'Home' }),
      },
      emitName: {
        type: String,
        default: '',
      },
    },
    methods: {
      onSubmit() {
        if (this.emitName) {
          this.$emit(this.emitName, true);
        } else {
          this.$router.push(this.to);
        }
      },
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Mobile/MobileBackMenu.vue